import script from "./NotFound.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotFound.vue?vue&type=script&setup=true&lang=ts"

import "./NotFound.vue?vue&type=style&index=0&id=643a6f34&scoped=true&lang=stylus"
script.__scopeId = "data-v-643a6f34"

export default script